import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

export const disabledFeedbackQuestions: {
  [sectionId in FeedbackSectionId]: { [questionId: number]: boolean };
} = {
  allocation: {},
  beneficiaries: {},
  budget: {
    80001: true,
    80011: true,
  },
  dates: {},
  description: {},
  finalize_report: {},
  interim_report: {},
  impact_summary: {
    40015: true,
    40010: true,
    40007: true,
    40008: true,
    40011: true,
    40021: true,
  },
  indicator_details: {},
  location: {},
  narrative: {},
  custom_questions: {},
  activities: {},
};

export const disabledQuestions: {
  [sectionId in FeedbackSectionId]: { [questionId: number]: boolean };
} = {
  activities: {},
  allocation: {
    20001: true,
    20002: true,
    20003: true,
    20004: true,
    20005: true,
    20006: true,
    20007: true,
    20010: true,
    20011: true,
    20012: true,
    20013: true,
    20014: true,
    20015: true,
    20017: true,
    20018: true,
    20019: true,
    20020: true,
    20021: true,
  },
  beneficiaries: {},
  budget: {
    80002: true,
    80006: true,
    80008: true,
  },
  dates: {},
  description: {},
  finalize_report: {},
  interim_report: {},
  impact_summary: {},
  indicator_details: {
    50002: true,
    50003: true,
    50004: true,
    50005: true,
    50006: true,
    50007: true,
    50008: true,
    50009: true,
    50010: true,
    50011: true,
    50012: true,
    50013: true,
    50014: true,
    50015: true,
    50016: true,
    50017: true,
    50018: true,
    50019: true,
    50020: true,
    50021: true,
    50022: true,
    50023: true,
    50024: true,
    50025: true,
    50026: true,
    50027: true,
    50028: true,
    50029: true,
    50030: true,
  },
  location: {},
  narrative: {},
  custom_questions: {},
};

const questionTexts = {
  1: 'Program description',
  10001: 'How long program has been running?',
  10002: 'Are your program\'s services short-term and scheduled, long-term and scheduled, or continuous? ',
  10003: 'Time period for this annual report',
  10004: 'Is it a short term or long term program?',
  10005: 'How many times do you implement this program over a twelve month period?',
  10006: 'When does (or did) initial planning and development for this program begin?',
  10007: 'Do you want to treat these implementations as separate programs each with their own annual report or as a single aggregate ' +
    'program with a single annual report?',
  30017: 'Where does your program operate?',
  40002: 'Let\'s customize our guidance. Please select the cause that best describes your program.',
  40003: 'Which service best describes your program?',
  40004: 'What term do you use for the people your program primarily helps?',
  40005: 'How does your program deliver its services?',
  40006: 'How does your program provide its services?',
  40007: 'Is training or education part of your programming?',
  40008: 'Does your program hope to change beneficiaries’ behavior or inspire them to take an action?',
  40009: 'Is your program a pilot program that is expected to be replicated elsewhere in the future if it is successful?',
  40010: 'How does your program improve the lives of beneficiaries?',
  40011: 'What is part of your program’s reach?',
  40015: 'Is this summary of impacts accurate?',
  40021: 'How does your program strengthen other organizations or programs that help beneficiaries?',
  40022: 'What term do you use for the intermediaries you directly serve?',
  50001: 'Impact Model Details:',
  50050: 'Impact Model notes',
  60001: 'Beneficiary demographics:',
  60050: 'Beneficiaries notes',
  70001: 'Success story:',
  70002: 'Lessons learned:',
  80003: 'Direct cost',
  80005: 'In kind donations',
  80007: 'Overhead (indirect) cost',
  80009: 'Backup documents',
  80011: 'Budget summary',
  110001: 'What is your service delivery method?',
  110002: 'How does this program primarily deliver services to beneficiaries?',
  110003: 'Does this program deliver services to beneficiaries in any additional way?',
  110004: 'Average value or length of time of services delivered',
  110005: 'Average number or frequency of services delivered',
  110006: 'Average duration of services delivered',
};

export const getQuestionText = (
  questionId: number | undefined,
  defaultText?: string,
) => {
  if (!questionId) return defaultText;
  return questionTexts[questionId] || defaultText;
};
